'use strict';

var dialog = require('../dialog');

exports.init = initialize;

function initialize() {
    wishlistPostOrder();
}

function wishlistPostOrder() {
    $(document).off('CordialTagging.WishlistPostOrder').on('CordialTagging.WishlistPostOrder', function (event, removedProducts, orderNumber) {
        if ($(document).find('.order-confirmation-details').length > 0 && removedProducts && orderNumber) {
            var auth_data = {
				email: $('.confirmation .billing-info .order-billing-email').text()
			};
            var contact_data = {
			    'channels': {
			        'email': {
			            'address': $('.confirmation .billing-info .order-billing-name').text()
			        }
			    },
			    'first_name': $('.confirmation .billing-info .order-billing-name').text().split(' ')[0],
				'last_name': $('.confirmation .billing-info .order-billing-name').text().split(' ')[1],
				'phone': $('.confirmation .billing-info .order-billing-phone').text(),
				'postal_code': $('.confirmation .billing-info .order-billing-geo .zip').text(),
				'source_create': 'order',
				'geo_location': {
				    'postal_code': $('.confirmation .billing-info .order-billing-geo .zip').text(),
				    'country': $('.confirmation .billing-info .order-billing-country').text(),
				    'state': $('.confirmation .billing-info .order-billing-geo .state').text(),
				    'city': $('.confirmation .billing-info .order-billing-geo .city').text()
				}
			};	

			$('.order-item').each(function(index, el) {
				var _this = $(this);
				_this.find('.productCardMetadata').each(function(key, v) {
					var thisItem = JSON.parse($(this).attr('data-product-gtm-json'));
                    if (removedProducts.indexOf(thisItem["skuid"]) > -1) {
                        var product = {};	
                        product.productID = thisItem["skuid"];
                        product.productName = thisItem["name"].replace(/\\/g, "");
                        product.category = thisItem["category"].replace(/\\/g, "");
                        product.price = thisItem["price"];
                        product.images = [_this.find('img').attr('src')];
                        product.url = window.location.origin + _this.find('.name').find('a').attr('href');
                        product.attr = { 
                            'manufacturer': thisItem["brand"] 
                        };

                        if (typeof crdl !== 'undefined' && typeof crdl === 'function') {
                            crdl('event', 'wishlist_remove', product); 
                        }
                    }
				});
			});	
        }
    });
}
